// /components/simulator/YearlyOutcomeTable.js

import TraditionalRentalYearlyTable from './tables/TraditionalRentalYearlyTable';
import BankLendingYearlyTable from './tables/BankLendingYearlyTable';
import RentToOwnYearlyTable from './tables/RentToOwnYearlyTable';
import RentToOwnGoldYearlyTable from './tables/RentToOwnGoldYearlyTable';
import RentToOwnRealEstateYearlyTable from './tables/RentToOwnRealEstateYearlyTable';
import RentToOwnBusinessYearlyTable from './tables/RentToOwnBusinessYearlyTable';
import RentToOwnStockYearlyTable from './tables/RentToOwnStockYearlyTable';
import GoldInvestmentYearlyTable from './tables/GoldInvestmentYearlyTable';
import StockInvestmentYearlyTable from './tables/StockInvestmentYearlyTable';
import BusinessInvestmentYearlyTable from './tables/BusinessInvestmentYearlyTable';

const YearlyOutcomeTable = ({ modelName, yearlyData }) => {
  switch (modelName) {
    case 'Traditional Rental':
      return <TraditionalRentalYearlyTable yearlyData={yearlyData} />;
    case 'Bank Lending':
      return <BankLendingYearlyTable yearlyData={yearlyData} />;
    case 'Rent-to-Own':
      return <RentToOwnYearlyTable yearlyData={yearlyData} />;
    case 'Rent-to-Own + Gold':
      return <RentToOwnGoldYearlyTable yearlyData={yearlyData} />;
    case 'Rent-to-Own + Real Estate':
      return <RentToOwnRealEstateYearlyTable yearlyData={yearlyData} />;
    // case 'Rent-to-Own + Business':
    //   return <RentToOwnBusinessYearlyTable yearlyData={yearlyData} />;
    case 'Rent-to-Own + Stock':
      return <RentToOwnStockYearlyTable yearlyData={yearlyData} />;
    case 'Gold Investment':
      return <GoldInvestmentYearlyTable yearlyData={yearlyData} />;
    case 'Stock Investment':
      return <StockInvestmentYearlyTable yearlyData={yearlyData} />;
    // case 'Business Investment':
    //   return <BusinessInvestmentYearlyTable yearlyData={yearlyData} />;
    default:
      return <div>Unknown model yearly breakdown</div>;
  }
};

export default YearlyOutcomeTable;
